import React from "react"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"

import { Dimensions, StyleSheet, Text, TouchableHighlight, TouchableOpacity, View } from "react-native"
import { getSportIcon } from "@Utils/utils"
import { Ionicons, MaterialIcons } from "@expo/vector-icons"

const { width, hieght } = Dimensions.get("screen")
export const ActivityCard = (props) => {
    const { sport, activityType, duration, icon, state } = props
    const finishedOrCanceled = state.code != "CREATED"

    return (
        <TouchableHighlight
            underlayColor={baseColors.black}
            onPress={() => props.onPress && props.onPress()}
            style={styles.cardContainer}
        >
            <>
                {finishedOrCanceled && (
                    <View style={styles.overlay}>
                        <View style={styles.badge}>
                            {state.code === "CANCELED" ? (
                                <MaterialIcons
                                    style={{ marginRight: 5 }}
                                    size={15}
                                    color={baseColors.orange.primary}
                                    name={"cancel"}
                                />
                            ) : (
                                <Ionicons
                                    style={{ marginRight: 5 }}
                                    size={15}
                                    color={baseColors.orange.primary}
                                    name={"checkmark-done-circle"}
                                />
                            )}

                            <OpenSansText textAlign={"center"} color={baseColors.orange.primary}>
                                {state.code === "CANCELED" ? "Annulé" : "Terminé"}
                            </OpenSansText>
                        </View>
                    </View>
                )}
                <View>{sport && getSportIcon(sport.name)}</View>
                <View>
                    <OpenSansText fontSize={16} fontWeight={"bold"} color={baseColors.white}>
                        {sport && sport.name}
                    </OpenSansText>
                    <OpenSansText fontSize={16} color={baseColors.white}>
                        {activityType && activityType.name}
                    </OpenSansText>
                </View>
                <View>
                    <OpenSansText textAlign={"center"} fontSize={16} fontWeight={"bold"} color={baseColors.white}>
                        {duration && duration}
                    </OpenSansText>
                    <OpenSansText fontSize={16} color={baseColors.white}>
                        Minutes
                    </OpenSansText>
                </View>
            </>
        </TouchableHighlight>
    )
}

const styles = StyleSheet.create({
    cardContainer: {
        marginVertical: 5,
        flexDirection: "row",
        backgroundColor: baseColors.green.primary,
        borderRadius: 10,
        padding: 20,
        flex: 1,
        paddingHorizontal: 30,
        width: width - 40,
        justifyContent: "space-between"
    },
    swipeableContainer: {
        width: width - 40,
        flexDirection: "row",
        alignItems: "center",
        alignContent: "center",
        flex: 1,
        justifyContent: "space-between"
    },
    badge: {
        justifyContent: "center",
        padding: 5,
        margin: 13,
        position: "absolute",
        alignItems: "center",
        alignContent: "center",
        backgroundColor: baseColors.white,
        borderRadius: 20,
        width: 90,
        zIndex: 10,
        flexDirection: "row"
    },
    overlay: {
        backgroundColor: "rgba(255,255,255,0.6)",
        width: width - 40,
        zIndex: 10,
        flex: 1,
        position: "absolute",
        height: 90,
        padding: 13,
        borderRadius: 10
    }
})
